import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'passwordStrength',
    pure: true,
    standalone: false
})
export class PasswordStrengthPipe implements PipeTransform {
  private scoreMappings = ['', 'Weak', 'Average', 'Strong', 'Very Strong'];

  transform(value: number) {
    return this.scoreMappings[value] || '';
  }
}
